module.exports = __webpack_public_path__ + "static/media/folder-line.ecdccb37.svg";